// Generated by Melange

import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm.ml",
  137,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "KkmPreferences"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Kkm"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Kassa"
    ]]
});

const Kassa = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm.ml",
  237,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "KkmPreferences"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Kkm"
          ]]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm.ml",
  335,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "KkmPreferences"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Kkm"
    ]]
});

const Kkm = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm.ml",
  431,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmPreferences"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const KkmPreferences = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm.ml",
  470,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.kassa.v1alpha1.Kkm.KkmPreferences";
}

function make(allow_autoclose_shiftOpt, allow_autoclose_withdrawOpt, allow_autotaxOpt, allow_ui_salesOpt, allow_ui_purchasesOpt, allow_ui_stornoOpt, allow_ui_markup_discountOpt, default_domainOpt, receipt_langOpt, param) {
  const allow_autoclose_shift = allow_autoclose_shiftOpt !== undefined ? allow_autoclose_shiftOpt : false;
  const allow_autoclose_withdraw = allow_autoclose_withdrawOpt !== undefined ? allow_autoclose_withdrawOpt : false;
  const allow_autotax = allow_autotaxOpt !== undefined ? allow_autotaxOpt : false;
  const allow_ui_sales = allow_ui_salesOpt !== undefined ? allow_ui_salesOpt : false;
  const allow_ui_purchases = allow_ui_purchasesOpt !== undefined ? allow_ui_purchasesOpt : false;
  const allow_ui_storno = allow_ui_stornoOpt !== undefined ? allow_ui_stornoOpt : false;
  const allow_ui_markup_discount = allow_ui_markup_discountOpt !== undefined ? allow_ui_markup_discountOpt : false;
  const default_domain = default_domainOpt !== undefined ? default_domainOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0);
  const receipt_lang = receipt_langOpt !== undefined ? receipt_langOpt : "";
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_purchases: allow_ui_purchases,
    allow_ui_storno: allow_ui_storno,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const merge_allow_autoclose_shift = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "allow_autoclose_shift",
    "allowAutocloseShift"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_autoclose_withdraw = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "allow_autoclose_withdraw",
    "allowAutocloseWithdraw"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_autotax = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "allow_autotax",
    "allowAutotax"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_sales = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "allow_ui_sales",
    "allowUiSales"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_purchases = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "allow_ui_purchases",
    "allowUiPurchases"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_storno = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "allow_ui_storno",
    "allowUiStorno"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_ui_markup_discount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    7,
    "allow_ui_markup_discount",
    "allowUiMarkupDiscount"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_default_domain = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    8,
    "default_domain",
    "defaultDomain"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
]));

const merge_receipt_lang = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    9,
    "receipt_lang",
    "receiptLang"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge(t1, t2) {
  return {
    allow_autoclose_shift: Curry._2(merge_allow_autoclose_shift, t1.allow_autoclose_shift, t2.allow_autoclose_shift),
    allow_autoclose_withdraw: Curry._2(merge_allow_autoclose_withdraw, t1.allow_autoclose_withdraw, t2.allow_autoclose_withdraw),
    allow_autotax: Curry._2(merge_allow_autotax, t1.allow_autotax, t2.allow_autotax),
    allow_ui_sales: Curry._2(merge_allow_ui_sales, t1.allow_ui_sales, t2.allow_ui_sales),
    allow_ui_purchases: Curry._2(merge_allow_ui_purchases, t1.allow_ui_purchases, t2.allow_ui_purchases),
    allow_ui_storno: Curry._2(merge_allow_ui_storno, t1.allow_ui_storno, t2.allow_ui_storno),
    allow_ui_markup_discount: Curry._2(merge_allow_ui_markup_discount, t1.allow_ui_markup_discount, t2.allow_ui_markup_discount),
    default_domain: Curry._2(merge_default_domain, t1.default_domain, t2.default_domain),
    receipt_lang: Curry._2(merge_receipt_lang, t1.receipt_lang, t2.receipt_lang)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "allow_autoclose_shift",
      "allowAutocloseShift"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "allow_autoclose_withdraw",
      "allowAutocloseWithdraw"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "allow_autotax",
      "allowAutotax"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "allow_ui_sales",
      "allowUiSales"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "allow_ui_purchases",
      "allowUiPurchases"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "allow_ui_storno",
      "allowUiStorno"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      7,
      "allow_ui_markup_discount",
      "allowUiMarkupDiscount"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      8,
      "default_domain",
      "defaultDomain"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
    Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      9,
      "receipt_lang",
      "receiptLang"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry.app(serialize, [
    writer,
    param.allow_autoclose_shift,
    param.allow_autoclose_withdraw,
    param.allow_autotax,
    param.allow_ui_sales,
    param.allow_ui_purchases,
    param.allow_ui_storno,
    param.allow_ui_markup_discount,
    param.default_domain,
    param.receipt_lang
  ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(allow_autoclose_shift, allow_autoclose_withdraw, allow_autotax, allow_ui_sales, allow_ui_purchases, allow_ui_storno, allow_ui_markup_discount, default_domain, receipt_lang) {
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_purchases: allow_ui_purchases,
    allow_ui_storno: allow_ui_storno,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.Kkm.KkmPreferences", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.allow_autoclose_shift,
      param.allow_autoclose_withdraw,
      param.allow_autotax,
      param.allow_ui_sales,
      param.allow_ui_purchases,
      param.allow_ui_storno,
      param.allow_ui_markup_discount,
      param.default_domain,
      param.receipt_lang
    ]);
  };
}

function constructor$1(allow_autoclose_shift, allow_autoclose_withdraw, allow_autotax, allow_ui_sales, allow_ui_purchases, allow_ui_storno, allow_ui_markup_discount, default_domain, receipt_lang) {
  return {
    allow_autoclose_shift: allow_autoclose_shift,
    allow_autoclose_withdraw: allow_autoclose_withdraw,
    allow_autotax: allow_autotax,
    allow_ui_sales: allow_ui_sales,
    allow_ui_purchases: allow_ui_purchases,
    allow_ui_storno: allow_ui_storno,
    allow_ui_markup_discount: allow_ui_markup_discount,
    default_domain: default_domain,
    receipt_lang: receipt_lang
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.Kkm.KkmPreferences", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, KkmPreferences, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.kassa.v1alpha1.Kkm";
}

function make$1(idOpt, nameOpt, tagOpt, stateOpt, serial_numOpt, ofd_provider_idOpt, ofd_provider_protocolOpt, ofd_device_idOpt, ofd_register_numOpt, address_streetOpt, address_street1Opt, address_street2Opt, create_time, preferences, shift_openedOpt, shift_idOpt, shift_open_time, shift_close_time, connectedOpt, connection_drop_time, connection_drop_reasonOpt, connection_drop_reason_codeOpt, offlineOpt, offline_start_time, offline_finish_time, activatedOpt, deactivate_time, deactivate_reason_codeOpt, deactivate_reason_messageOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const name = nameOpt !== undefined ? nameOpt : "";
  const tag = tagOpt !== undefined ? tagOpt : "";
  const state = stateOpt !== undefined ? stateOpt : "";
  const serial_num = serial_numOpt !== undefined ? serial_numOpt : "";
  const ofd_provider_id = ofd_provider_idOpt !== undefined ? ofd_provider_idOpt : 0;
  const ofd_provider_protocol = ofd_provider_protocolOpt !== undefined ? ofd_provider_protocolOpt : "";
  const ofd_device_id = ofd_device_idOpt !== undefined ? ofd_device_idOpt : "";
  const ofd_register_num = ofd_register_numOpt !== undefined ? ofd_register_numOpt : "";
  const address_street = address_streetOpt !== undefined ? address_streetOpt : "";
  const address_street1 = address_street1Opt !== undefined ? address_street1Opt : "";
  const address_street2 = address_street2Opt !== undefined ? address_street2Opt : "";
  const shift_opened = shift_openedOpt !== undefined ? shift_openedOpt : false;
  const shift_id = shift_idOpt !== undefined ? shift_idOpt : 0;
  const connected = connectedOpt !== undefined ? connectedOpt : false;
  const connection_drop_reason = connection_drop_reasonOpt !== undefined ? connection_drop_reasonOpt : "";
  const connection_drop_reason_code = connection_drop_reason_codeOpt !== undefined ? connection_drop_reason_codeOpt : "";
  const offline = offlineOpt !== undefined ? offlineOpt : false;
  const activated = activatedOpt !== undefined ? activatedOpt : false;
  const deactivate_reason_code = deactivate_reason_codeOpt !== undefined ? deactivate_reason_codeOpt : "";
  const deactivate_reason_message = deactivate_reason_messageOpt !== undefined ? deactivate_reason_messageOpt : "";
  return {
    id: id,
    name: name,
    tag: tag,
    state: state,
    serial_num: serial_num,
    ofd_provider_id: ofd_provider_id,
    ofd_provider_protocol: ofd_provider_protocol,
    ofd_device_id: ofd_device_id,
    ofd_register_num: ofd_register_num,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2,
    create_time: create_time,
    preferences: preferences,
    shift_opened: shift_opened,
    shift_id: shift_id,
    shift_open_time: shift_open_time,
    shift_close_time: shift_close_time,
    connected: connected,
    connection_drop_time: connection_drop_time,
    connection_drop_reason: connection_drop_reason,
    connection_drop_reason_code: connection_drop_reason_code,
    offline: offline,
    offline_start_time: offline_start_time,
    offline_finish_time: offline_finish_time,
    activated: activated,
    deactivate_time: deactivate_time,
    deactivate_reason_code: deactivate_reason_code,
    deactivate_reason_message: deactivate_reason_message
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tag = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "tag",
    "tag"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "state",
    "state"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_serial_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "serial_num",
    "serialNum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_ofd_provider_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "ofd_provider_id",
    "ofdProviderId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_ofd_provider_protocol = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    7,
    "ofd_provider_protocol",
    "ofdProviderProtocol"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_ofd_device_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    8,
    "ofd_device_id",
    "ofdDeviceId"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_ofd_register_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    9,
    "ofd_register_num",
    "ofdRegisterNum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    18,
    "address_street",
    "addressStreet"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    19,
    "address_street1",
    "addressStreet1"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address_street2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    20,
    "address_street2",
    "addressStreet2"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    21,
    "create_time",
    "createTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

const merge_preferences = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    22,
    "preferences",
    "preferences"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: KkmPreferences.name,
    make: KkmPreferences.make,
    from_proto: KkmPreferences.from_proto,
    from_proto_exn: KkmPreferences.from_proto_exn,
    to_proto: KkmPreferences.to_proto,
    to_proto$p: KkmPreferences.to_proto$p,
    merge: KkmPreferences.merge,
    to_json: KkmPreferences.to_json,
    from_json_exn: KkmPreferences.from_json_exn,
    from_json: KkmPreferences.from_json
  })
]));

const merge_shift_opened = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    23,
    "shift_opened",
    "shiftOpened"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_shift_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    24,
    "shift_id",
    "shiftId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_shift_open_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    25,
    "shift_open_time",
    "shiftOpenTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_shift_close_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    26,
    "shift_close_time",
    "shiftCloseTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  })
]));

const merge_connected = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    50,
    "connected",
    "connected"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_connection_drop_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    51,
    "connection_drop_time",
    "connectionDropTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

const merge_connection_drop_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    52,
    "connection_drop_reason",
    "connectionDropReason"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_connection_drop_reason_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    53,
    "connection_drop_reason_code",
    "connectionDropReasonCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_offline = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    54,
    "offline",
    "offline"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_offline_start_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    55,
    "offline_start_time",
    "offlineStartTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

const $$let$5 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_offline_finish_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    56,
    "offline_finish_time",
    "offlineFinishTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

const merge_activated = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    57,
    "activated",
    "activated"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const $$let$6 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_deactivate_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    58,
    "deactivate_time",
    "deactivateTime"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

const merge_deactivate_reason_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    59,
    "deactivate_reason_code",
    "deactivateReasonCode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_deactivate_reason_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    60,
    "deactivate_reason_message",
    "deactivateReasonMessage"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$1(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    name: Curry._2(merge_name, t1.name, t2.name),
    tag: Curry._2(merge_tag, t1.tag, t2.tag),
    state: Curry._2(merge_state, t1.state, t2.state),
    serial_num: Curry._2(merge_serial_num, t1.serial_num, t2.serial_num),
    ofd_provider_id: Curry._2(merge_ofd_provider_id, t1.ofd_provider_id, t2.ofd_provider_id),
    ofd_provider_protocol: Curry._2(merge_ofd_provider_protocol, t1.ofd_provider_protocol, t2.ofd_provider_protocol),
    ofd_device_id: Curry._2(merge_ofd_device_id, t1.ofd_device_id, t2.ofd_device_id),
    ofd_register_num: Curry._2(merge_ofd_register_num, t1.ofd_register_num, t2.ofd_register_num),
    address_street: Curry._2(merge_address_street, t1.address_street, t2.address_street),
    address_street1: Curry._2(merge_address_street1, t1.address_street1, t2.address_street1),
    address_street2: Curry._2(merge_address_street2, t1.address_street2, t2.address_street2),
    create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
    preferences: Curry._2(merge_preferences, t1.preferences, t2.preferences),
    shift_opened: Curry._2(merge_shift_opened, t1.shift_opened, t2.shift_opened),
    shift_id: Curry._2(merge_shift_id, t1.shift_id, t2.shift_id),
    shift_open_time: Curry._2(merge_shift_open_time, t1.shift_open_time, t2.shift_open_time),
    shift_close_time: Curry._2(merge_shift_close_time, t1.shift_close_time, t2.shift_close_time),
    connected: Curry._2(merge_connected, t1.connected, t2.connected),
    connection_drop_time: Curry._2(merge_connection_drop_time, t1.connection_drop_time, t2.connection_drop_time),
    connection_drop_reason: Curry._2(merge_connection_drop_reason, t1.connection_drop_reason, t2.connection_drop_reason),
    connection_drop_reason_code: Curry._2(merge_connection_drop_reason_code, t1.connection_drop_reason_code, t2.connection_drop_reason_code),
    offline: Curry._2(merge_offline, t1.offline, t2.offline),
    offline_start_time: Curry._2(merge_offline_start_time, t1.offline_start_time, t2.offline_start_time),
    offline_finish_time: Curry._2(merge_offline_finish_time, t1.offline_finish_time, t2.offline_finish_time),
    activated: Curry._2(merge_activated, t1.activated, t2.activated),
    deactivate_time: Curry._2(merge_deactivate_time, t1.deactivate_time, t2.deactivate_time),
    deactivate_reason_code: Curry._2(merge_deactivate_reason_code, t1.deactivate_reason_code, t2.deactivate_reason_code),
    deactivate_reason_message: Curry._2(merge_deactivate_reason_message, t1.deactivate_reason_message, t2.deactivate_reason_message)
  };
}

function spec$1(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$5 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$6 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "tag",
      "tag"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "state",
      "state"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "serial_num",
      "serialNum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "ofd_provider_id",
      "ofdProviderId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      7,
      "ofd_provider_protocol",
      "ofdProviderProtocol"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      8,
      "ofd_device_id",
      "ofdDeviceId"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      9,
      "ofd_register_num",
      "ofdRegisterNum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      18,
      "address_street",
      "addressStreet"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      19,
      "address_street1",
      "addressStreet1"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      20,
      "address_street2",
      "addressStreet2"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      21,
      "create_time",
      "createTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      22,
      "preferences",
      "preferences"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: KkmPreferences.name,
      make: KkmPreferences.make,
      from_proto: KkmPreferences.from_proto,
      from_proto_exn: KkmPreferences.from_proto_exn,
      to_proto: KkmPreferences.to_proto,
      to_proto$p: KkmPreferences.to_proto$p,
      merge: KkmPreferences.merge,
      to_json: KkmPreferences.to_json,
      from_json_exn: KkmPreferences.from_json_exn,
      from_json: KkmPreferences.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      23,
      "shift_opened",
      "shiftOpened"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      24,
      "shift_id",
      "shiftId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      25,
      "shift_open_time",
      "shiftOpenTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      26,
      "shift_close_time",
      "shiftCloseTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$2.name,
      make: $$let$2.make,
      from_proto: $$let$2.from_proto,
      from_proto_exn: $$let$2.from_proto_exn,
      to_proto: $$let$2.to_proto,
      to_proto$p: $$let$2.to_proto$p,
      merge: $$let$2.merge,
      to_json: $$let$2.to_json,
      from_json_exn: $$let$2.from_json_exn,
      from_json: $$let$2.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      50,
      "connected",
      "connected"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      51,
      "connection_drop_time",
      "connectionDropTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$3.name,
      make: $$let$3.make,
      from_proto: $$let$3.from_proto,
      from_proto_exn: $$let$3.from_proto_exn,
      to_proto: $$let$3.to_proto,
      to_proto$p: $$let$3.to_proto$p,
      merge: $$let$3.merge,
      to_json: $$let$3.to_json,
      from_json_exn: $$let$3.from_json_exn,
      from_json: $$let$3.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      52,
      "connection_drop_reason",
      "connectionDropReason"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      53,
      "connection_drop_reason_code",
      "connectionDropReasonCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      54,
      "offline",
      "offline"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      55,
      "offline_start_time",
      "offlineStartTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$4.name,
      make: $$let$4.make,
      from_proto: $$let$4.from_proto,
      from_proto_exn: $$let$4.from_proto_exn,
      to_proto: $$let$4.to_proto,
      to_proto$p: $$let$4.to_proto$p,
      merge: $$let$4.merge,
      to_json: $$let$4.to_json,
      from_json_exn: $$let$4.from_json_exn,
      from_json: $$let$4.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      56,
      "offline_finish_time",
      "offlineFinishTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$5.name,
      make: $$let$5.make,
      from_proto: $$let$5.from_proto,
      from_proto_exn: $$let$5.from_proto_exn,
      to_proto: $$let$5.to_proto,
      to_proto$p: $$let$5.to_proto$p,
      merge: $$let$5.merge,
      to_json: $$let$5.to_json,
      from_json_exn: $$let$5.from_json_exn,
      from_json: $$let$5.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      57,
      "activated",
      "activated"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      58,
      "deactivate_time",
      "deactivateTime"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$6.name,
      make: $$let$6.make,
      from_proto: $$let$6.from_proto,
      from_proto_exn: $$let$6.from_proto_exn,
      to_proto: $$let$6.to_proto,
      to_proto$p: $$let$6.to_proto$p,
      merge: $$let$6.merge,
      to_json: $$let$6.to_json,
      from_json_exn: $$let$6.from_json_exn,
      from_json: $$let$6.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      59,
      "deactivate_reason_code",
      "deactivateReasonCode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      60,
      "deactivate_reason_message",
      "deactivateReasonMessage"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))))))))))))))))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry.app(serialize$1, [
    writer,
    param.id,
    param.name,
    param.tag,
    param.state,
    param.serial_num,
    param.ofd_provider_id,
    param.ofd_provider_protocol,
    param.ofd_device_id,
    param.ofd_register_num,
    param.address_street,
    param.address_street1,
    param.address_street2,
    param.create_time,
    param.preferences,
    param.shift_opened,
    param.shift_id,
    param.shift_open_time,
    param.shift_close_time,
    param.connected,
    param.connection_drop_time,
    param.connection_drop_reason,
    param.connection_drop_reason_code,
    param.offline,
    param.offline_start_time,
    param.offline_finish_time,
    param.activated,
    param.deactivate_time,
    param.deactivate_reason_code,
    param.deactivate_reason_message
  ]);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(id, name, tag, state, serial_num, ofd_provider_id, ofd_provider_protocol, ofd_device_id, ofd_register_num, address_street, address_street1, address_street2, create_time, preferences, shift_opened, shift_id, shift_open_time, shift_close_time, connected, connection_drop_time, connection_drop_reason, connection_drop_reason_code, offline, offline_start_time, offline_finish_time, activated, deactivate_time, deactivate_reason_code, deactivate_reason_message) {
  return {
    id: id,
    name: name,
    tag: tag,
    state: state,
    serial_num: serial_num,
    ofd_provider_id: ofd_provider_id,
    ofd_provider_protocol: ofd_provider_protocol,
    ofd_device_id: ofd_device_id,
    ofd_register_num: ofd_register_num,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2,
    create_time: create_time,
    preferences: preferences,
    shift_opened: shift_opened,
    shift_id: shift_id,
    shift_open_time: shift_open_time,
    shift_close_time: shift_close_time,
    connected: connected,
    connection_drop_time: connection_drop_time,
    connection_drop_reason: connection_drop_reason,
    connection_drop_reason_code: connection_drop_reason_code,
    offline: offline,
    offline_start_time: offline_start_time,
    offline_finish_time: offline_finish_time,
    activated: activated,
    deactivate_time: deactivate_time,
    deactivate_reason_code: deactivate_reason_code,
    deactivate_reason_message: deactivate_reason_message
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.Kkm", spec$1(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.id,
      param.name,
      param.tag,
      param.state,
      param.serial_num,
      param.ofd_provider_id,
      param.ofd_provider_protocol,
      param.ofd_device_id,
      param.ofd_register_num,
      param.address_street,
      param.address_street1,
      param.address_street2,
      param.create_time,
      param.preferences,
      param.shift_opened,
      param.shift_id,
      param.shift_open_time,
      param.shift_close_time,
      param.connected,
      param.connection_drop_time,
      param.connection_drop_reason,
      param.connection_drop_reason_code,
      param.offline,
      param.offline_start_time,
      param.offline_finish_time,
      param.activated,
      param.deactivate_time,
      param.deactivate_reason_code,
      param.deactivate_reason_message
    ]);
  };
}

function constructor$3(id, name, tag, state, serial_num, ofd_provider_id, ofd_provider_protocol, ofd_device_id, ofd_register_num, address_street, address_street1, address_street2, create_time, preferences, shift_opened, shift_id, shift_open_time, shift_close_time, connected, connection_drop_time, connection_drop_reason, connection_drop_reason_code, offline, offline_start_time, offline_finish_time, activated, deactivate_time, deactivate_reason_code, deactivate_reason_message) {
  return {
    id: id,
    name: name,
    tag: tag,
    state: state,
    serial_num: serial_num,
    ofd_provider_id: ofd_provider_id,
    ofd_provider_protocol: ofd_provider_protocol,
    ofd_device_id: ofd_device_id,
    ofd_register_num: ofd_register_num,
    address_street: address_street,
    address_street1: address_street1,
    address_street2: address_street2,
    create_time: create_time,
    preferences: preferences,
    shift_opened: shift_opened,
    shift_id: shift_id,
    shift_open_time: shift_open_time,
    shift_close_time: shift_close_time,
    connected: connected,
    connection_drop_time: connection_drop_time,
    connection_drop_reason: connection_drop_reason,
    connection_drop_reason_code: connection_drop_reason_code,
    offline: offline,
    offline_start_time: offline_start_time,
    offline_finish_time: offline_finish_time,
    activated: activated,
    deactivate_time: deactivate_time,
    deactivate_reason_code: deactivate_reason_code,
    deactivate_reason_message: deactivate_reason_message
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.Kkm", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "KkmPreferences"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Kkm, {
  KkmPreferences: KkmPreferences,
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "KkmPreferences"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Kkm"
    ]]
}, V1alpha1, {
  Kkm: Kkm
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "KkmPreferences"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Kkm"
          ]]
      },
      "V1alpha1"
    ]]
}, Kassa, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "KkmPreferences"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Kkm"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Kassa"
    ]]
}, Buhta, {
  Kassa: Kassa
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
